import * as React from 'react';
import { setupBlogPostsIndicator } from '../scripts/blog';
import { setupMobileNavigation } from '../scripts/mobilenav';
import '../styles/hamburger.styl';
import '../styles/header.styl';
import template from '../templates/static-header.pug';
import { Pug } from './Pug';

setupMobileNavigation();

export class GlobalHeader extends React.Component {
    componentDidMount(): void {
        setupBlogPostsIndicator();
    }

    render() {
        return <Pug template={template} />;
    }
}
